module.exports = __webpack_public_path__ + "img/icon-preview.d95f5826.svg";